function SectionCandidateRecentActivities() {
    return (
        <>
            <div className="panel panel-default site-bg-white m-t30">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0"><i className="far fa-list-alt" />Recent Activities</h4>
                </div>
                <div className="panel-body wt-panel-body">
                    <div className="dashboard-list-box list-box-with-icon">
                        <ul>
                            <li>
                                <i className="fa fa-envelope text-success list-box-icon" />Nikol Tesla has sent you <a href="#" className="text-success">private message!</a>
                                <a href="#" className="close-list-item color-lebel clr-red">
                                    <i className="far fa-trash-alt" />
                                </a>
                            </li>
                            <li>
                                <i className="fa fa-suitcase text-primary list-box-icon" />Your job for
                                <a href="#" className="text-primary">Web Designer</a>
                                has been approved!
                                <a href="#" className="close-list-item color-lebel clr-red">
                                    <i className="far fa-trash-alt" />
                                </a>
                            </li>
                            <li>
                                <i className="fa fa-bookmark text-warning list-box-icon" />
                                Someone bookmarked your
                                <a href="#" className="text-warning">SEO Expert</a>
                                Job listing!
                                <a href="#" className="close-list-item color-lebel clr-red">
                                    <i className="far fa-trash-alt" />
                                </a>
                            </li>
                            <li>
                                <i className="fa fa-tasks text-info list-box-icon" />
                                Your job listing Core
                                <a href="#" className="text-info">PHP Developer</a> for Site Maintenance is expiring!
                                <a href="#" className="close-list-item color-lebel clr-red">
                                    <i className="far fa-trash-alt" />
                                </a>
                            </li>
                            <li>
                                <i className="fa fa-paperclip text-success list-box-icon" />
                                You have new application for
                                <a href="#" className="text-success"> UI/UX Developer &amp; Designer! </a>
                                <a href="#" className="close-list-item color-lebel clr-red">
                                    <i className="far fa-trash-alt" />
                                </a>
                            </li>
                            <li>
                                <i className="fa fa-suitcase text-danger list-box-icon" />
                                Your Magento Developer job expire
                                <a href="#" className="text-danger">Renew</a>  now it.
                                <a href="#" className="close-list-item color-lebel clr-red">
                                    <i className="far fa-trash-alt" />
                                </a>
                            </li>
                            <li>
                                <i className="fa fa-star site-text-orange list-box-icon" />
                                David cope left a
                                <a href="#" className="site-text-orange"> review 4.5</a> for Real Estate Logo
                                <a href="#" className="close-list-item color-lebel clr-red">
                                    <i className="far fa-trash-alt" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionCandidateRecentActivities;